module.exports = __webpack_public_path__ + "img/FERREIRO.dd7af93b.jpg";